'use es6';

import { createAction } from 'redux-actions';
import { TYPING_MESSAGE_EXPIRED } from '../constants/actionTypes';
export const typingMessageExpired = createAction(TYPING_MESSAGE_EXPIRED, ({
  message
}) => ({
  message
}));